'use strict';

var sanitizeHtml = require('sanitize-html');
var $ = require('jquery');
var allowedTags = ['ol', 'ul', 'li', 'p', 'a', 'span', 'div', 'img', 'b', 'i', 'em', 'strong', 'br'];

/** After paste event occurs, takes target and cleans the change to ensure crap html is not in there.
 * @module PasteHandler
 * @requires sanitize-html
 * @requires jquery
 */
function PasteHandler() {
	this.setup = function(root) {
		document.addEventListener('paste', function(ev) {
			if (!ev || !ev.target) return;
			var $target = $(ev.target).closest('[contenteditable]');
			if (!$target.length) return;
			setTimeout(function() {
				var dirtyHtml = $target.html();
				$target.html(sanitizeHtml(dirtyHtml, { allowedTags: allowedTags }));
			}, 100);
		});
	};
}

module.exports = PasteHandler;
